"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RIVALRY_CONFIG = void 0;
exports.resolveRivalryConfig = resolveRivalryConfig;
exports.DEFAULT_RIVALRY_CONFIG = {
    method: 'summation',
    teamA: { name: 'Team A', color: '#1976d2' },
    teamB: { name: 'Team B', color: '#e53935' },
    rivalrySize: 4,
    countingScores: 1,
};
/** Merge partial or missing rivalry config when useRivalry is enabled. */
function resolveRivalryConfig(event) {
    if (!event?.useRivalry)
        return null;
    const r = event.rivalry;
    return {
        method: r?.method ?? exports.DEFAULT_RIVALRY_CONFIG.method,
        teamA: {
            name: r?.teamA?.name?.trim() || exports.DEFAULT_RIVALRY_CONFIG.teamA.name,
            color: r?.teamA?.color ?? exports.DEFAULT_RIVALRY_CONFIG.teamA.color,
        },
        teamB: {
            name: r?.teamB?.name?.trim() || exports.DEFAULT_RIVALRY_CONFIG.teamB.name,
            color: r?.teamB?.color ?? exports.DEFAULT_RIVALRY_CONFIG.teamB.color,
        },
        rivalrySize: Number(r?.rivalrySize) > 0 ? Number(r.rivalrySize) : exports.DEFAULT_RIVALRY_CONFIG.rivalrySize,
        countingScores: Number(r?.countingScores) > 0
            ? Number(r.countingScores)
            : exports.DEFAULT_RIVALRY_CONFIG.countingScores,
    };
}
